import apiClient from "@/services/ApiClient"
import { crudActions } from "./CrudActions"
import { kanbanActions } from "./KanbanActions"

export default {
  ...crudActions("mesocicles"),
  ...kanbanActions("mesocicles"),
  getPdf(id) {
    return apiClient.get(`/mesocicles/${id}/pdf`)
  },
  getProfileActivitat(exercici_id) {
    return apiClient.get(`/exercicis/profile/${exercici_id}`)
  },
  getProfileSessioActivitat(sessio_activitat_id) {
    return apiClient.get(`/sessions-activitats/${sessio_activitat_id}`)
  },
  updateProfileSessioActivitat(sessio_activitat_id, data) {
    return apiClient.post(`/sessions-activitats/${sessio_activitat_id}`, data)
  },
  importProgressio(params) {
    return apiClient.put(`/mesocicles/kanban-columns/import/progression`, params)
  },
}
